function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0187 6.67867L9.32365 3.98367L11.2717 2.03467L13.9657 4.72867L12.0187 6.67867ZM5.07965 13.6247L2.10265 13.8957L2.36665 10.9397L7.98365 5.32268L10.6797 8.01868L5.07965 13.6247ZM15.4037 3.33767L15.4027 3.33667L12.6647 0.598675C11.9237 -0.140325 10.6507 -0.175325 9.94865 0.529675L0.952652 9.52567C0.626652 9.85067 0.424652 10.2827 0.382652 10.7397L0.00365188 14.9097C-0.0223481 15.2047 0.0826519 15.4967 0.292652 15.7067C0.481652 15.8957 0.736652 15.9997 0.999652 15.9997C1.03065 15.9997 1.06065 15.9987 1.09065 15.9957L5.26065 15.6167C5.71865 15.5747 6.14965 15.3737 6.47465 15.0487L15.4717 6.05167C16.1997 5.32167 16.1687 4.10367 15.4037 3.33767Z"
});

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.de2f8f07.svg";
export { ForwardRef as ReactComponent };